import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/image-studio/page.tsx");
